// List of car makes by starting letters buttons component
import React from 'react';
import styles from '../css/carMakesLettersBtns.module.css';

export default function CarMakesLettersBtns({ fetchCarMakesByLetter, carMakesList, children }) {
  return (
    <div className={styles.lettersContainer}>
      <div>
        <button className={styles.letterBtn} onClick={fetchCarMakesByLetter}>
          A - F
        </button>
        <button className={styles.letterBtn} onClick={fetchCarMakesByLetter}>
          G - K
        </button>
        <button className={styles.letterBtn} onClick={fetchCarMakesByLetter}>
          L - P
        </button>
        <button className={styles.letterBtn} onClick={fetchCarMakesByLetter}>
          Q - T
        </button>
        <button className={styles.letterBtn} onClick={fetchCarMakesByLetter}>
          U - Z
        </button>
      </div>
      <div>{carMakesList.length > 0 && <div>{children}</div>}</div>
    </div>
  );
}
